import { useEffect, useRef } from "react";

export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const els = root.querySelectorAll(".reveal");
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("is-visible")),
      { threshold: 0.12 }
    );
    const revealPassed = () => {
      els.forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add("is-visible");
      });
    };
    els.forEach((el) => io.observe(el));
    revealPassed();
    window.addEventListener("scroll", revealPassed, { passive: true });
    return () => { io.disconnect(); window.removeEventListener("scroll", revealPassed); };
  }, []);
  return ref;
}
